import type { FaireProductEntity } from "../../entity_types/product";

export const p_tm5my47fry: FaireProductEntity = {
  token: "p_tm5my47fry",
  type: "product",
  name: "Let's Play Mahjong 1000 Piece Puzzle",
  brandToken: "b_4l0np8cc8r",
  brandName: "WerkShoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/c7f80482daf57c7d2054469756ff617be38f1e64d1d0a3c2e14922be162b54af.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/56206edd99f29591bb6d0d111635d9399c5575959949a97c670b81e1b8df680c.jpeg",
    "https://cdn.faire.com/fastly/410c211852a84871b0314dcc98ae0c535ca2903602578bc70f67ece798c76095.jpeg",
    "https://cdn.faire.com/fastly/8883c88a637508367ae2a8862c542f615444deb1d2c3d608d40de3aa0a874cfa.jpeg",
  ],
  priceDollars: 16.5,
  description:
    'Gather your friends and family for a beautiful, challenging evening with the "Let\'s Play Mahjong" 1000-piece jigsaw puzzle by artist Teresa Chan. This stunning puzzle transforms the beloved game of Mahjong into a mesmerizing, artful centerpiece.\n\nThe intricate design features a central lotus bloom surrounded by stylized Mahjong tiles, delicate florals, and charming, whimsical figures. Rich shades of sage green, powder pink, and navy create a sophisticated palette. As a final, luxurious touch, the puzzle includes gold foil detailing that catches the light and elevates the finished image to a piece of displayable art.\n\nWith 1000 pieces and a finished size of 24" x 24", this square puzzle is a perfect gift for puzzle enthusiasts, game lovers, and anyone who appreciates vibrant, culturally inspired illustration.\n\n𝐏𝐫𝐨𝐝𝐮𝐜𝐭 𝐃𝐞𝐭𝐚𝐢𝐥𝐬\n• 1000-piece jigsaw puzzle, embellished with gold foil\n• Assembled puzzle size: 24" W x 24" H\n• Includes 1 reference art insert\n• 100% recycled board & non-toxic vegetable-based ink\n• Precision cut pieces with minimal puzzle dust\n• Resealable zip-top bag for puzzle piece storage\n• Premium slipcase drawer box\n• Box - 9" L x 9" W x 2" D\n• Recommended age: 13+ years\n• Art created globally, imported',
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:31.408Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
